import React from 'react'

import BaseModal from '../BaseModal2'
import Checkbox from '../../../atoms/Checkbox'
import OpenConversation from '../../Accordion/OpenConversations/OpenConversation'
import Button from '../../../atoms/Button'

import { uniqueArray } from '@SonarCX/utilities'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'
import { useQueueState } from '@SonarCX/providers/QueueStateProvider'
import { useSocket } from '@SonarCX/providers/SocketProvider'
import useStyles from './styles'

const CloseConversationsModal = ({ related, onClose }) => {
  const { user } = useEnvironment()
  const { handleClose } = useQueueState()
  const {
    api: { endSessions, rejectConversation }
  } = useSocket()

  const [selected, setSelected] = React.useState([])

  const classes = useStyles()

  const handleSelect = React.useCallback(session => {
    setSelected(old => {
      if (old.includes(session)) {
        return old.filter(id => id !== session)
      }

      return uniqueArray([...old, session])
    })
  }, [])

  const handleSubmit = React.useCallback(() => {
    related.forEach(convo => {
      const { session, users } = convo
      const isYours = users.includes(user?.id)

      if (selected.includes(session)) {
        handleClose(session, () => {
          if (isYours) {
            endSessions([session], true)
          } else {
            rejectConversation(session)
          }
        })
      }
    })
  }, [related, selected, handleClose, endSessions, rejectConversation, user])

  return (
    <BaseModal
      open
      onClose={onClose}
      title='YOU HAVE OPEN CONVERSATIONS'
      PaperProps={{ style: { width: '50%' } }}
    >
      <div className={classes.titleBlock}>
        <div className={classes.title}>Select conversations to close.</div>

        <div className={classes.subTitle}>
          Closing a conversation will also end it.
        </div>
      </div>

      <div className={classes.conversations}>
        {related.map(convo => (
          <div key={convo.session} className={classes.conversation}>
            <Checkbox
              checked={selected.includes(convo.session)}
              onChange={() => handleSelect(convo.session)}
              className={classes.checkBox}
            />

            <OpenConversation
              conversation={convo}
              onClick={handleSelect}
              modal
            />
          </div>
        ))}
      </div>

      <div className={classes.controls}>
        <Button onClick={onClose} invert='true' className={classes.button}>
          CANCEL
        </Button>

        <Button
          onClick={handleSubmit}
          disabled={selected.length === 0}
          className={classes.button}
        >
          CLOSE SELECTED
        </Button>
      </div>
    </BaseModal>
  )
}

export default CloseConversationsModal
